import InputDropzone from './input-dropzone';

export default InputDropzone;
